import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SmartSearchIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.373 0.739C4.72 0.179 6.332 0.446 7.429 1.542C8.801 2.914 8.873 5.092 7.648 6.55L9.831 8.733L9.369 9.196L7.186 7.014C6.103 7.922 4.624 8.117 3.373 7.597L3.499 7.294L3.624 6.993C4.735 7.455 6.062 7.233 6.965 6.331C8.16 5.136 8.16 3.199 6.965 2.005C6.062 1.102 4.735 0.881 3.624 1.343L3.499 1.042L3.373 0.739ZM3.143 1.245L3.214 1.475L3.759 3.219L5.383 3.767L5.606 3.841V4.512L5.383 4.587L3.759 5.134L3.143 7.109H2.463L1.846 5.134L0.223 4.587L0 4.512V3.841L0.223 3.767L1.846 3.219L2.392 1.475L2.463 1.245H3.143ZM2.422 3.573L2.373 3.733L2.214 3.786L1.054 4.177L2.214 4.568L2.373 4.621L2.422 4.781L2.802 6L3.233 4.621L4.55 4.177L3.233 3.733L2.802 2.353L2.422 3.573Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SmartSearchIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.373 0.739C4.72 0.179 6.332 0.446 7.429 1.542C8.801 2.914 8.873 5.092 7.648 6.55L9.831 8.733L9.369 9.196L7.186 7.014C6.103 7.922 4.624 8.117 3.373 7.597L3.499 7.294L3.624 6.993C4.735 7.455 6.062 7.233 6.965 6.331C8.16 5.136 8.16 3.199 6.965 2.005C6.062 1.102 4.735 0.881 3.624 1.343L3.499 1.042L3.373 0.739ZM3.143 1.245L3.214 1.475L3.759 3.219L5.383 3.767L5.606 3.841V4.512L5.383 4.587L3.759 5.134L3.143 7.109H2.463L1.846 5.134L0.223 4.587L0 4.512V3.841L0.223 3.767L1.846 3.219L2.392 1.475L2.463 1.245H3.143ZM2.422 3.573L2.373 3.733L2.214 3.786L1.054 4.177L2.214 4.568L2.373 4.621L2.422 4.781L2.802 6L3.233 4.621L4.55 4.177L3.233 3.733L2.802 2.353L2.422 3.573Z" />
        </SvgIcon>
    );
};
